import {Component, OnInit} from '@angular/core';
import {CommonService} from '../services/common.service';

@Component({
   selector: 'app-mission-capital',
   templateUrl: './mission-capital.component.html',
   styleUrls: ['./mission-capital.component.css']
})
export class MissionCapitalComponent implements OnInit {

   path;

   constructor(private common: CommonService) {
   }

   ngOnInit(): void {
      this.path = this.common;
      const loc = window.location.href;
      if (!loc.includes('platform-services#nitin')) {
         window.scrollTo(0, 0);
      }
   }
}
